<script>
import _ from 'lodash';
import { VTextarea } from 'vuetify/lib';
import BReadOnlyTextField from '../BReadOnlyTextField';
import ValidationField from "@/components/base_components/ValidationField";
export default {
  functional: true,
  props: {
    readOnly: Boolean,
    uuid: String,
    propPath: String,
    formRef: String,
    ...VTextarea.options.props
  },
  render(createElement, context) {
    if (!context.props.readOnly) {
      const customData = {
        class: { 'b-text-area--input--has-label': context.props.label },
        props: {
          outlined: true,
          hideDetails: 'auto',
          autoGrow: true,
        }
      };
      context.data.props = context.props;
      _.merge(context.data, customData);

      const slot = ({ error, deleteServerError }) => {
        const data = {
          ...context.data,
          props: {
            ...context.data.props,
            errorMessages: error
          },
          on: {
            ...context.data.on,
            keyup: () => deleteServerError(),
            input: () => deleteServerError(),
          }
        }
        return createElement(VTextarea, data);
      }

      return createElement(ValidationField,
          {
            props: {
              uuid: context.data.props.uuid,
              propPath: context.data.props.propPath,
              formRef: context.data.props.formRef
            },
            scopedSlots: { default: slot }
          });
    } else {
      context.data.props = context.props;
      return createElement(BReadOnlyTextField, context.data);
    }
  }
};
</script>

<style lang="scss">
.b-text-area--input--has-label {
  & > .v-input__control {
    padding-top: 4px;
  }
}
</style>
